<template>
 <app-layout class="" style="background-color: #f3f4f6">
    <template v-slot:headerTitle>
        Dashboard
    </template>
            <template v-slot:tcmainnav> </template>

   <div>

         <div class=" ">
           <br>
                  <div class="bg-white d-flex flex-row overflow-hidden  px-2 py-2 my-8 mx-4  sm:rounded-lg" style="box-shadow: 0px 1px 3px #777">
                     <img src="imgs/tally_banner.png" alt="">
                        <div class="text-left mt-10">
                    Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam fugiat culpa quia possimus molestiae id sapiente ad eveniet, aliquid, eum sint fuga eius, ratione suscipit ut minus voluptates dicta nesciunt.
                        </div> 
                 </div>
                 </div>
          <!-- <div class="panel-wrapper">
            <div class="panel-body d-flex flex-row">
                        <img src="imgs/tally_banner.png" alt="">
                        <div class="text-left mt-10">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Totam fugiat culpa quia possimus molestiae id sapiente ad eveniet, aliquid, eum sint fuga eius, ratione suscipit ut minus voluptates dicta nesciunt.
                        </div>
            </div>
          </div> -->
        <p class=" text-2xl recommend">Recommended Add-Ons</p>
         <!-- cards start from here -->
          <DxScrollView 
        direction="horizontal" 
        :scrollByContent="true"
        :scrollByThumb="true" 
        ShowScrollbar="never"
        id="scroll"  height="140px" width="95%" style="margin-left:31px; margin-bottom:20px">
        <div class="cont">
            <div class="cardnen" v-for="(d, b) in addonsData" :key="b">
              <div class="mt-2 ml-2 text-gray-400 text-xl icon">
              <i class="fas fa-spa"></i>
                </div> 
            <a class="mtnpaiin text-sm no-decoration ml-2 pr-2 mt-2 leading-4" v-bind:href="'d.url'">{{ d.name }}</a>
            </div>
        </div>
         </DxScrollView>
        <!-- <DxToast
        v-model:visible="isVisible"
        v-model:message="messag"
        v-model:type="type"
      />  -->
          <!-- cards ends here -->
         <!-- lower card from here -->
         <p class=" text-2xl recommend">Recommended Modules</p>
      <div class="card-container">
          <div class="card" v-for="(d, b) in modulesData" :key="b">
            <main class="card-header ">
              <div class="icon1">
             <i class="fab fa-font-awesome"></i>
              </div>
              <p class="header-title">{{d.name}}</p>
              <p>Lorem ipsum, dolor sit amet consectetur adipisicing elit. Quasi voluptatem at provident!</p>
               <div class="d-flex  flex-row">
               <a href="" class="floating-button1">More Info</a>
              &nbsp;  &nbsp;  &nbsp;  &nbsp; 
               <a href="" class="floating-button0 ">Install</a>
              <!-- <p class="header-para">Install</p> -->
               </div>
            </main>
          </div>
        </div>
          <!-- lower cards end here -->
   </div>
  </app-layout>
</template>
<script>
// import { DxToast } from 'devextreme-vue/toast';
import DxScrollView from 'devextreme-vue/scroll-view';
// import AppLayout from   './tallyClinicAppLayout.vue';
import AppLayout from "@/Layouts/AppLayout.vue";

import addOnsJson from '../json/addons.json';
import modulesJson from '../json/modules.json';
export default {
    components:{
        AppLayout,
        DxScrollView ,
        //  DxToast,
    }
    ,
    data() {
      return {
        addonsData:addOnsJson,
        modulesData:modulesJson,
      };
  },
  methods: {
    // getAddOns(){

    // }
  },
   mounted() {
    // this.getAddOns();
    // this.getModules();
   



  },
}
</script>
<style>
/* main page */
.main-content {
background-color: #f3f4f6;
	/* width: calc(100% - 250px); */
	/* height: 100vh; */
	margin-left: 212px;
	padding-bottom: 10px;
}


.no-decoration{
text-decoration: none;
}

.no-decoration:hover{
text-decoration: none;
}


@media only screen and (max-width: 420px){
	.main-content {
		width: 100%;
		margin-left: 0;
		z-index: -1;
		position: relative;
	}
}

@media only screen and (max-width: 768px){
	.main-content {
		width: 100%;
		margin-left: 0;
		z-index: -1;
		position: relative;
	}
}

/* cards css start from here */
.cardnen {
    width: 150px;
    height: 150px;
    background-color: #fff;
    margin: 9px;
    padding: 6px;
    border-radius: 5px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    position: relative;
    cursor: pointer !important;
    /* z-index: 1; */
    transition: all ease 0.2s;
}

.cardnen:hover {
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
    transform: translateY(-0.4rem);
    background-color:#10b981 ;

}
 .cardnen.icon i{
     color: #10b981;     
}
.cont {
    display: flex;
    margin-left: -5px; 
     
}

.mtnpaiin {
    position: absolute;
    color:#949494 ; 
    text-align:left;
}

.cardnen:hover .mtnpaiin{
 color: #fff !important; 
}

.cardnen:hover .icon{
color: #fff !important;
}
a{
  text-decoration: none;
}

/* lower card start from here */
.card-container {
  /* margin: 1rem; */
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  algin-items: center;
  margin-left: 30px;
   margin-right: 30px;
  margin-top: 10px;
  
 
}

.card {
   background-color: white;
  border-radius: .50rem;
  border: 1px solid white;
  overflow: hidden;
}

.card-header .header-title {
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  margin-top: 1rem;
  color: black;
}
.header-para{
   font-size: 1rem;
  font-weight: bold;
  margin-bottom: 1rem;
  margin-top: 1rem;
}
.card-header {
    /* padding: 1rem 1.75rem; */
    margin-bottom: 0;
    background-color: white;
    border-bottom: white;
}
.icon1{
  font-size: 50px;
  color: #10b981;
}
/* lower button0 lower card */
.floating-button0 {
  text-decoration: none;
  display: inline-block;
  width: 90px;
  height: 40px;
  border-radius: 5px;
  line-height: 40px;
  margin: 10px 20px;
  text-align: center;
  font-weight:bolder;
  color: black;
  /* color: #524f4e;
  background: white;
  box-shadow: 0 8px 15px rgba(0, 0, 0, .1); */
}
.floating-button0:hover {
  background: #10b981;
  box-shadow: #10b981;
  color: white;
  transform: translateY(-5px);
}
/* lower button */
/* lower button0 lower card */
.floating-button1 {
  text-decoration: none;
  display: inline-block;
  width: 90px;
  height: 40px;
  line-height: 40px;
  margin: 10px 0px;
  /* text-align: center; */
  font-weight:bolder;
  color: black;
}
.floating-button1:hover {
  color: #10b981;
  
}
.recommend{
  margin-left: 33px;
}

/* lower card end here */

</style>